import { EResumeCategory } from 'shared/enums/EResumeCategory';
import { EditProfileMediaResumeItemContainer } from './EditProfileMediaResumeItem.styles';
import { IconButton, Tooltip, Typography } from '@material-ui/core';
import { DragIcon, Switch } from '@room-match/shared-ui-components';
import { useEditProfileDndControls } from '../../../hooks/useEditProfileDndControls';

type EditProfileMediaResumeItemProps = {
  isAttached: boolean;
  categoryName: EResumeCategory;
  credits: number;
  onToggle: (id: string) => void;
  id: string;
  disableToggle?: boolean;
};

const EditProfileMediaResumeItem = ({
  isAttached,
  categoryName,
  credits,
  onToggle,
  id,
  disableToggle = false,
}: EditProfileMediaResumeItemProps) => {
  const { attributes, listeners, style, setNodeRef } = useEditProfileDndControls(id);

  const sortableControls =
    isAttached && !disableToggle
      ? {
          container: {
            ref: setNodeRef,
          },
          item: {
            ...attributes,
            ...listeners,
          },
        }
      : {};

  return (
    <EditProfileMediaResumeItemContainer {...sortableControls.container} style={style}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 10,
          alignItems: 'center',
          flexShrink: 0,
          pointerEvents: disableToggle ? 'none' : 'unset',
          opacity: disableToggle ? 0.2 : 1,
        }}
      >
        <IconButton style={{ padding: 0, cursor: 'grab' }} {...sortableControls.item}>
          <DragIcon />
        </IconButton>
        <Typography>{categoryName}</Typography>
        <Typography color="primary">{`${credits} ${credits > 1 ? 'Credits' : 'Credit'}`}</Typography>
      </div>
      <div style={{ flex: 1, display: 'flex', justifyContent: 'end', marginRight: -15 }}>
        <Tooltip title="Add a credit to enable this category." disableHoverListener={!disableToggle}>
          <div>
            <Switch checked={isAttached} disabled={disableToggle} toggle={() => onToggle(id)} />
          </div>
        </Tooltip>
      </div>
    </EditProfileMediaResumeItemContainer>
  );
};

export default EditProfileMediaResumeItem;
